import React from "react";
import { Component } from "react";
import './cost-report-table.component.css';
import { CorstReportLineChart } from "./cost-report-line-chart/cost-report-line-chart.component";
import { CostReportSummary } from "./cost-report-summary/cost-report-summary.component";
import { CostDistribution } from "./cost-distribution/cost-distribution.component";
import { CostReportFilter } from "./cost-report-filter.component";
import { DataTable } from "../../../common/table/data-table/data-table-component";
import { ChartHeaderDropdown } from "../../../common/data-header/chart-header-dropdown.component";
export class CostReportTable extends Component {   

    render() {
       

        const dataTable=[
            {
                headerName:"Top 5 Users",
                HeaderItem:[
                    {
                        name:"User Name"
                    },
                    {
                        name:"Net Amount"
                    }, {
                        name:"Tax Amount"
                    }
                ],
                dataItem:[{            
                    columnItem1:"aisha.e.fernan@email.com",
                    columnItem2: 104102.72,
                    columnItem3: 10344.2
                }, {          
                    columnItem1:"aili.a.suddock@email.com",
                    columnItem2: 1234.56,
                    columnItem3: 789
                }           
                ]

            },

            {
                headerName:"Top 5 Circuits",
                HeaderItem:[
                    {
                        name:"User Name"
                    },
                    {
                        name:"Circuit Number"
                    }, {
                        name:"Net Amount"
                    }
                ],
                dataItem:[{            
                    columnItem1:"aisha.e.fernan@email.com",
                    columnItem2: "+40758113931",
                    columnItem3: 1357.04
                }, {          
                    columnItem1:"aili.a.suddock@email.com",
                    columnItem2: "+40744342707",
                    columnItem3: 470.26
                }           
                ]

            }, {
                headerName:"Top 5 Charge Category",
                HeaderItem:[
                    {
                        name:"Charge Category"
                    },
                    {
                        name:"Net Amount"
                    }, {
                        name:"Tax Amount"
                    }
                ],
                dataItem:[{            
                    columnItem1:"Fixed fees and other fees",
                    columnItem2: 112950.97,
                    columnItem3: 12717.14
                }, {          
                    columnItem1:"International Calls",
                    columnItem2: 5470.41,
                    columnItem3: 755.16
                } , {          
                    columnItem1:"Roaming Voice",
                    columnItem2: 1070.03,
                    columnItem3: 188.57
                }            
                ]

            }


        ]
        return(
            <>
    
            <div className="container-mt-7 report-main-container">
                <CostReportFilter />
                <div className="grap-summary-container cost-table-chart">
                    <CostReportSummary/>
                    <CostDistribution/>
                </div>              
                <div className="cost-table-container data-table">                
                    
                </div>
                <CorstReportLineChart/>
            </div>
          
            </>
        )
    }
}